import { render, staticRenderFns } from "./catalog-mobile.vue?vue&type=template&id=298dc04e&scoped=true&"
import script from "./catalog-mobile.vue?vue&type=script&lang=js&"
export * from "./catalog-mobile.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "298dc04e",
  null
  ,true
)

export default component.exports